module.exports = __webpack_public_path__ + "img/8.ee1b6ec.jpg";